<template>
  <layout>
    <h2>{{ "daily_report_transactions" | translate }}</h2>

    <div class="mb-3">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          v-model="searchKey"
          @keyup.enter="filterTransactions"
        />

        <div class="input-group-append">
          <div class="input-group-btn" @click="filterTransactions">
            <button class="btn btn-primary">
              <i class="fa fa-fw fa-filter"></i>
              {{ 'filter' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-warning" v-if="!hasTransactions">{{ "no_record_found" | translate }}</div>

    <table class="table table-sm" v-if="hasTransactions">
      <thead class="thead-light">
        <tr>
          <th>{{ "id" | translate }}</th>
          <th>{{ 'date' | translate }}</th>
          <th>{{ 'ref' | translate }}</th>
          <th>{{ 'people' | translate }}</th>
          <th>{{ "account" | translate }}</th>
          <th>{{ 'in' | translate }}</th>
          <th>{{ 'out' | translate }}</th>
          <th>{{ "currency" | translate }}</th>
          <th class="w-min">@</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="trans in filteredTransactions" :key="trans.id">
          <td>{{ trans.id }}</td>
          <td>{{ trans.dailyReportDate }}</td>
          <td>{{ trans.ref }}</td>
          <td>{{ trans.people }}</td>
          <td>{{ trans.account }}</td>
          <td>{{ trans.in | number:2 }}</td>
          <td>{{ trans.out | number:2 }}</td>
          <td>{{ trans.currency | translate }}</td>
          <td>
            <a :href="`#/dailyReports/${trans.dailyReportId}`">
              <i class="fa fa-fw fa-arrow-right"></i>
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="5">{{ 'total' | translate }}</td>
          <td>{{ totalIn }}</td>
          <td>{{ totalOut }}</td>
          <td colspan="2"></td>
        </tr>
      </tfoot>
    </table>

    <!-- <pre>{{ transactions }}</pre> -->

    <simple-paginator :hasNext="hasNext" :lastDoc="lastDoc" @change="loadData"></simple-paginator>
  </layout>
</template>

<script>
import FirebaseDailyReport from "@/services/FirebaseDailyReport";
import _ from "lodash";
import { search } from "@/lib/helper";

export default {
  data() {
    return {
      size: 20,

      lastDoc: null,
      hasNext: false,

      searchKey: "",

      dailyReports: [],
      transactions: [],
      filteredTransactions: [],
    };
  },

  computed: {
    hasTransactions() {
      return this.filteredTransactions && this.filteredTransactions.length;
    },

    totalIn() {
      return _.reduce(
        this.filteredTransactions,
        (sum, item) => (item.in ? sum + item.in : sum),
        0
      );
    },

    totalOut() {
      return _.reduce(
        this.filteredTransactions,
        (sum, item) => (item.out ? sum + item.out : sum),
        0
      );
    },
  },

  created() {
    this.loadData();
  },
  methods: {
    loadData(startAfter) {
      this.hasNext = false;
      this.lastDoc = null;
      return FirebaseDailyReport.list(this.size, startAfter).then((data) => {
        this.hasNext = data.hasNext;
        this.lastDoc = data.docs[data.docs.length - 1];
        this.dailyReports = data.docs.map((doc) => doc.data());

        this.extractTransactions();
        this.filterTransactions();
      });
    },

    extractTransactions() {
      this.transactions = _.flatMap(
        this.dailyReports,
        (report) => report.transactions
      );
    },

    filterTransactions() {
      if (!this.searchKey || this.searchKey.length === 0) {
        this.filteredTransactions = this.transactions;
        return;
      }
      this.filteredTransactions = _.filter(this.transactions, (trans) => {
        return search(this.searchKey)
          .val(trans.ref)
          .val(trans.people)
          .val(trans.account)
          .any();
      });
    },
  },
};
</script>
